module.exports = __webpack_public_path__ + "static/media/S-WEB-Goal-12.c96b79eb.png";